function init() {
  const priceButton = document.querySelector('.js-price-button');

  if (priceButton) {
    const monthly = priceButton.querySelector('.monthly');
    const annual = priceButton.querySelector('.annual');
    const highlight = priceButton.querySelector('.highlight');
    const monthlyAmount = document.querySelector('.price.monthly');
    const annualAmount = document.querySelector('.price.annual');

    priceButton.addEventListener('click', () => {
      if (monthly.classList.contains('active')) {
        monthly.classList.remove('active');
        annual.classList.add('active');
        highlight.classList.remove('monthly');
        highlight.classList.add('annual');
        setTimeout(() => {
          annualAmount.classList.remove('hide-fast');
          annualAmount.classList.add('show-fast');
        }, 200);
        monthlyAmount.classList.add('hide-fast');
        monthlyAmount.classList.remove('show-fast');
      } else {
        annual.classList.remove('active');
        monthly.classList.add('active');
        highlight.classList.remove('annual');
        highlight.classList.add('monthly');
        annualAmount.classList.add('hide-fast');
        annualAmount.classList.remove('show-fast');
        setTimeout(() => {
          monthlyAmount.classList.remove('hide-fast');
          monthlyAmount.classList.add('show-fast');
        }, 200);
      }
    });
  }
}

(() => {
  init();
})();
